import {ADD_SUGGESTED_DAMAGE_IMAGE, DELETE_DAMAGE_IMAGE, SET_DAMAGE_IMAGES, UPDATE_DAMAGE_IMAGE} from './dispatchTypes';
import {DELETED, USE_EXISTING} from "../utils/constants";
import {calculateDamageKey} from "./conditionActions";


export const loadImageList = (condition) => async (dispatch) => {
    let damageImages = [];
    if (condition?.damages) {
        damageImages = condition.damages.map(damage => {
            if (damage.imageHref) {
                if (condition.copied || condition.repurposed === "Y") {
                    return {
                        url: damage.imageHref,
                        key: damage.damageId,
                        previousKey: calculateDamageKey(damage),
                        status: USE_EXISTING
                    }
                } else {
                    return {
                        url: damage.imageHref,
                        key: damage.damageId
                    }
                }
            } else {
                return null
            }
        });
    }
    setDamageImages(damageImages.filter(n => n))(dispatch);
};

export const setDamageImages = (damageImages) => dispatch => {
    console.debug("setting damage images to... ", damageImages);
    dispatch({
        type: SET_DAMAGE_IMAGES,
        damageImages
    });
};

export const deleteDamageImage = (damageId) => dispatch => {
    dispatch({
        type: DELETE_DAMAGE_IMAGE,
        payload: {key: damageId}
    })
};

export const hasActiveImage = (damageId) => (dispatch, getState) => {
    if (!damageId || !getState().damageImages) {
        return false
    }
    const damageImages = getState().damageImages;
    const damageImage = damageImages.find(img => img.status !== DELETED && img.key === damageId);
    return !!damageImage
};

export const updateDamageImage = (damageId, imageHref) => (dispatch) => {
    dispatch({
        type: UPDATE_DAMAGE_IMAGE,
        payload: {
            key: damageId,
            url: imageHref
        }
    })
};

export const getActiveImage = (damageId) => (dispatch, getState) => {
    const activeImage = getState().damageImages.find(image => image.key === damageId);
    return activeImage?.url;
};

export const getActiveImageObject = (damageId) => (dispatch, getState) => {
    const damageImages = getState().damageImages;
    
    return damageImages.find(damageImage => {
        if (damageImage.status === DELETED) return false;
        return damageImage.key === damageId;
    });
};

export const addSuggestedDamageImage = (damageId, imageHref, imageAction = null) => dispatch => {
    dispatch({
        type: ADD_SUGGESTED_DAMAGE_IMAGE,
        payload: { 
            key: damageId,
            url: imageHref,
            imageAction
        }
    })
}

